import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import EnumerationCard from "../../../Components/Card/EnumerationCard";
import Confirmation from "../../../Components/Modal/Confirmation";

import { makeStyles } from "@material-ui/core/styles";
import { updateDefs } from "../Services";
import { userLogs } from "../../../Js/Common";

const EnumerationList = (props) => {
    // Hooks
    const classes = useStyles();

    // State    
    const [enumData, setEnumData] = useState([]);
    const [confirmModal, setConfirmModal] = useState(false);
    const [enumCurrentKeyData, setEnumCurrentKeyData] = useState(null);

    // Redux state
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

    // React logic hooks
    useEffect(() => {
        setEnumData(props.enumData);
    }, [props.enumData])


    const handleTopBtn = async () => {
        let newData = enumData.keydata;
        let pos = newData.findIndex(obj => obj.id === enumCurrentKeyData.id);
        newData.splice(pos, 1);
        enumData.keydata = newData;
        await updateDefs(enumData, enumData.uid, enumData.site_uuid);

         // logs value
         let res1 = {};
         res1.oldValue = enumCurrentKeyData;
         res1.newValue = "";
         let outcome = {}
         outcome.action = "delete";
         outcome.value = res1;

         // insert log for enumeration
         let logResponse = await userLogs({
            actor: userInfo.uid,
            verb: "enum",
            target: enumData.uid,
            outcome: outcome,
            site_uuid: userInfo.site_uuid,
        });

        setEnumData(enumData);
        resetState();
    }

    const handleIsDeleted = (keyDataObj) => {
        setEnumCurrentKeyData(keyDataObj);
        setConfirmModal(!confirmModal);
    }

    const handleIsEdit = (keyDataObj) => {
        props.isEnumeration(false, 'edit', keyDataObj);
    }

    const resetState = () => {
        setEnumCurrentKeyData(null);
        setConfirmModal(false);
    }

    return (
        <>
            <Grid container spacing={0} sx={{ flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center' }}>
                <Grid item >                  
                    <Button sx={{ backgroundColor: '#3eda00ff', textTransform: 'inherit', borderRadius: 10 ,fontWeight: '600',color: '#5f5600ff','&:hover': { backgroundColor: 'primary.main', color: '#FFFFFF' }, '@media (min-width: 1636px)':{
                      fontSize: "1.2rem",px: 2
                    }}}  onClick={() => { props.isEnumeration(false, 'create', null) }}>
                        Add
                    </Button>
                </Grid>
            </Grid>
            <Grid
                container
                spacing={3}
                 
                sx={{ mt: 1, height: '64vh', overflow: 'auto', px: 2 }}>
                {enumData && enumData.keydata && enumData.keydata.length > 0 && (
                    <>
                        {enumData.keydata.map((obj, index) => {
                            return (
                                <EnumerationCard
                                    key={`enum_${index}`}
                                    keydata={obj}
                                    onPressDelete={(val) => { handleIsDeleted(val) }}
                                    onPressEdit={(val) => { handleIsEdit(val) }}
                                />
                            );
                        })}
                    </>
                )}
            </Grid>
            <Confirmation
                image="delete"
                primaryText="Do you want to delete it?"
                visible={confirmModal}
                positiveClick={handleTopBtn}
                negativeClick={() => { setConfirmModal(false) }}
                toggleModal={(flag) => setConfirmModal(flag)}
            ></Confirmation>
        </>
    )
}

const useStyles = makeStyles({
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.6em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        },
    },
});
export default EnumerationList;